import React, { useState, useEffect } from "react";
import { useField } from "formik";

export default function NumberIncrement(props) {
  const { label } = props;
  const [field, meta, helpers] = useField(props.name);
  const { value } = meta;
  const { setValue } = helpers;

  const decrement = (n) => {
    if (n !== 0) {
      setValue(n - 1);
    }
  };

  const increment = (n) => {
    setValue(n + 1);
  };

  return (
    <div className="flex  items-center  p-3">
      <div className="grid grow grid-cols-3">
        <div className="col-span-2 grow">{label}</div>
        <div className="col-span-1 flex grow items-center text-center ">
          <button
            type="button"
            className="h-10 w-10 flex-none rounded-full bg-[#4CC887] font-bold text-black pb-1"
            onClick={() => decrement(value)}
          >
            -
          </button>
          <div className="grow font-bold ">{value}</div>
          <button
            type="button"
            className="h-10 w-10 flex-none rounded-full bg-[#4CC887] font-bold text-black"
            onClick={() => increment(value)}
          >
            +
          </button>
        </div>
      </div>
    </div>
  );
}

NumberIncrement.defaultProps = {
  callBack: (e) => console.log(e),
  label: "",
};
